import React from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import {
    mediumDesktop,
    tablet,
    hugeDesktop,
    largeDesktop,
    semiLargeDesktop,
} from 'helpers/utils/screensizes';


const SectionWithVideo = (props: any) => {
    const { content } = props;
    const [isHugeDesktopSize] = useMediaQuery(hugeDesktop);
    const [isSemiLargeDesktopSize] = useMediaQuery(semiLargeDesktop);
    const [ismediumDesktopSize] = useMediaQuery(mediumDesktop);
    const [isLargeDesktopSize] = useMediaQuery(largeDesktop);

    return (
        <div className={`md:px-100 pt-60 pb-85 2xl:px-208 ${content.additional_css ?? ''}`}>
            {content?.title && 
            <div className="block text-28 font-medium leading-10 text-primary-black pb-20 xl:text-36 2xl:text-48 lg:leading-[3.25rem] text-center">{content?.title}</div>
            }
            <div className="video-container flex justify-center">
                <iframe
                    src={content?.video_link?.href}
                    width="100%"
                    loading="lazy"
                    height={
                        isHugeDesktopSize ? '720px' :
                        isSemiLargeDesktopSize ? '480px' :
                        ismediumDesktopSize ? '500px' :
                        isLargeDesktopSize ? '600px' :
                        '320px'
                    }
                ></iframe>
            </div>
        </div>
    )
};

export default SectionWithVideo;